import { Link } from 'react-router-dom';
import { MapPinOff } from 'lucide-react';

import { Button } from '../components/Button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <MapPinOff className="h-12 w-12 text-slate-300" aria-hidden />
      <h1 className="text-xl font-semibold text-slate-900">Страница не найдена</h1>
      <p className="max-w-md text-sm text-slate-500">
        Адрес указан неверно или раздел был перемещён.
      </p>
      <Link to="/board">
        <Button variant="secondary">На доску выпуска</Button>
      </Link>
    </div>
  );
}

export default NotFoundPage;
